/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Sad({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Sad_svg__a)"><path d="M6.6 6a.6.6 0 1 0-1.2 0v1.5a.6.6 0 0 0 1.2 0V6ZM10 5.4a.6.6 0 0 1 .6.6v1.5a.6.6 0 1 1-1.2 0V6a.6.6 0 0 1 .6-.6ZM5.333 11.5a.6.6 0 0 1-.666-1C5.447 9.98 6.33 9.4 8 9.4c1.671 0 2.552.58 3.333 1.1a.6.6 0 1 1-.666 1c-.72-.48-1.356-.9-2.667-.9-1.311 0-1.948.42-2.667.9Z" /><path fillRule="evenodd" d="M8 .4a7.6 7.6 0 1 0 0 15.2A7.6 7.6 0 0 0 8 .4ZM1.6 8a6.4 6.4 0 1 1 12.8 0A6.4 6.4 0 0 1 1.6 8Z" clipRule="evenodd" /></g><defs><clipPath id="Sad_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;